<template lang="pug">
  .row
    .col-12
      header.mb-4
        h1#tittle {{$route.name}}
    .col-12
      form(@submit.prevent="editUser")
        b-card( border-variant="primary" header-bg-variant="primary" header-text-variant="white" id="card-header-color")
          template(v-slot:header)
            h5.text-white.m-0 Datos personales
          .row.d-flex.justify-content-end
              .form-group.col-md-6.mb-3
                label Nombres
                input.form-control(type="text" v-model="form.name" required="true")
              .form-group.col-md-6
                label Apellidos
                input.form-control(type="text" v-model="form.lastname" required="true")
              .form-group.col-md-6.mb-3
                label Rut
                input.form-control(type="text" v-model="form.rut" required="true")
              .form-group.col-md-6
                label Email
                input.form-control(type="email" v-model="form.email" required="true")
              .form-group.col-md-6.mb-3
                label Contraseña
                input.form-control(:type="passwordVisible ? 'text' : 'password'" v-model="form.password")
              .form-group.col-md-6
                label Repita contraseña
                input.form-control(:type="passwordVisible ? 'text' : 'password'" v-model="form.password")
              .form-group.col-md-6.d-flex.align-items-center
                input.form-check-input.me-2(type="checkbox" id="view-pass" @click='togglePasswordVisibility')
                label.form-check-label.pt-2(for="view-pass") Ver contraseña
              .form-group.col-md-6(v-if="clientLogin === 'reunion-tributaria'")
                input.form-check-input.me-2(type="checkbox" v-model="form.anual" :checked="form.anual" style="transform: scale(1.5); margin-right: 8px; border-color: grey")
                label Alumno anual
        b-card.my-5( border-variant="primary" header-bg-variant="primary" header-text-variant="white")
          template(v-slot:header)
            h5.text-white.m-0 Permisos de aplicaciones
          b-card(v-if="clientLogin === 'Entel' || clientLogin === 'Puerto Columbo'" border-variant="light")
            .row
              .form-group.col-auto.align-self-center
                h5.text.m-0 Empresas
              .form-group.col
                multiselect(
                  v-model="form.companies"
                  :options="options"
                  :multiple="true"
                  group-values="subsidiary"
                  group-label="name"
                  :group-select="true"
                  placeholder="Seleccione"
                  track-by="nombre"
                  :custom-label="subsidiaryLabel"
                )
            p
            p
          b-card(v-if="clientLogin === 'Entel' || clientLogin === 'Puerto Columbo'" border-variant="light")
            h5.text Amulen Personal
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-ap" @click="selectAllAmulenPersonal" v-model="allSelected.appsAmulenPersonal")
                label.form-check-label(for="check-all-ap") {{ selectText.textAP }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="app in appsAmulenPersonal")
                    input.form-check-input(type="checkbox" :id="app.id" v-model="form.appIdsAmulenPersonal" @click="select" :value="app.id")
                    label.form-check-label(:for="app.id") {{app.name}}
                    p
          b-card(v-if="clientLogin === 'Entel' || clientLogin === 'Puerto Columbo'" border-variant="light")
            h5.text Amulen
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-ac" @click="selectAllAmulenCore" v-model="allSelected.appsAmulenCore")
                label.form-check-label(for="check-all-ac") {{ selectText.textAC }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="app in appsAmulenCore")
                    input.form-check-input(type="checkbox" :id="app.id" v-model="form.appIdsAmulenCore" @click="select" :value="app.id")
                    label.form-check-label(:for="app.id") {{app.name}}
                    p
          b-card(v-if="clientLogin === 'Entel'" border-variant="light")
            h5.text  Visto Bueno
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-vb" @click="selectAllVistoBueno" v-model="allSelected.appsVistoBueno")
                label.form-check-label(for="check-all-vb") {{ selectText.textVB }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="app in appsVistoBueno")
                    input.form-check-input(type="checkbox" :id="app.id" v-model="form.appIdsVistoBueno" @click="select" :value="app.id")
                    label.form-check-label(:for="app.id") {{app.name}}
                    p
          b-card(v-if="['enseñas','Aulatributaria','cursos-grabados','reunion-tributaria'].includes(clientLogin)" border-variant="light")
            h5.text Elearning
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-e" @click="selectAllElearning" v-model="allSelected.appsElearning")
                label.form-check-label(for="check-all-e") {{ selectText.textE }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-if="['cursos-grabados','enseñas','Aulatributaria','reunion-tributaria'].includes(clientLogin)" v-for="app in appsElearning")
                    input.form-check-input(type="checkbox" :id="app.id" v-model="form.appIdsElearning" @click="select" :value="app.id")
                    span.fw-bold='#{{app.number}}'
                    |  {{app.title}}
                    p
          b-card(v-if="clientLogin === 'Entel'" border-variant="light")
            h5.text Agenda App
            .row.d-flex.justify-content-end
              .form-group.form-check.col-auto
                input.form-check-input(type="checkbox" id="check-all-ag" @click="selectAllAgendaApp" v-model="allSelected.appsAgendaApp")
                label.form-check-label(for="check-all-ag") {{ selectText.textAG }}
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="app in appsAgendaApp")
                    input.form-check-input(type="checkbox" :id="app.id" v-model="form.appIdsAgendaApp" @click="select" :value="app.id")
                    label.form-check-label(:for="app.id") {{app.name}}
          b-card(v-if="clientLogin === 'Entel'" border-variant="light")
            h5.text Perfil Agenda App
            .card-body
              form(action="/")
                .row.d-flex.flex-wrap
                  .form-group.form-check.col-6.col-md-3(v-for="appP in agendaProfile")
                    input.form-check-input(type="radio" :id="appP.id" v-model="form.selectAgendaProfile" :value="appP.id")
                    label.form-check-label(:for="appP.id") {{appP.name}}
                    p
                label(v-if="form.selectAgendaProfile === 'expert'") Seleccione al técnico:
                v-select(v-if="form.selectAgendaProfile === 'expert'" :options="staffs" :reduce="staff => staff.id" label="nombre" v-model="form.expertId" placeholder="Ingrese nombre o rut")
        .col-12.d-flex.justify-content-between.mb-5
          button#buttonCancel.button.px-5 Cancelar
          button#buttonSave.button.px-5 Guardar
</template>

<script>
// @ is an alias to /src
import DefaultLayout from '@/layouts/DefaultLayout'
import { appisAmulenCore, appisAmulenApi, appisElearning2 } from '../utils/axiosInstances'

export default {
  name: 'editUser',
  data () {
    return {
      appsAmulenPersonal: [
        { id: 'admin', name: 'Administración' },
        { id: 'upload', name: 'Añadir Archivos' },
        { id: 'edit', name: 'Editar' },
        { id: 'reports', name: 'Ver indicadores' },
        { id: 'addPersonal', name: 'Agregar Personal' },
        { id: 'viewFile', name: 'Ver Archivo' },
        { id: 'allEnterprise', name: 'Ver todas las Empresas' },
        { id: 'toReceivesEmail', name: 'Recibir notificaciones via correo' },
        { id: 'download', name: 'Descargar Archivos' },
        { id: 'validate', name: 'Validar Archivos' },
        { id: 'intenarlPersonal', name: 'Mostrar Personal Interno' }
      ],
      appsAmulenCore: [
        { id: 'adminUsers', name: 'Administrar usuarios' },
        { id: 'adminSettings', name: 'Administrar ajustes' }
      ],
      appsVistoBueno: [
        { id: 'panel', name: 'Panel' },
        { id: 'task', name: 'Tareas' },
        { id: 'provisioneds', name: 'Provisionales' },
        { id: 'rejected', name: 'Rechazar' },
        { id: 'editTask', name: 'Editar Tarea' }
      ],
      appsElearning: [],
      appsAgendaApp: [
        { id: 'dashboard', name: 'Dashboard' },
        { id: 'close', name: 'Close' },
        { id: 'detail', name: 'Details' },
        { id: 'upload', name: 'Upload' },
        { id: 'map', name: 'Map' },
        { id: 'oneplace', name: 'One place' },
        { id: 'search', name: 'Search' }
      ],
      agendaProfile: '',
      allListCompanies: [],
      formatedListCompanies: [],
      allListSubsidiary: [],
      formatedListSubsidiary: [],
      options: [],
      passwordVisible: false,
      selected: [],
      selectText: {
        textAP: 'Seleccionar todos',
        textAC: 'Seleccionar todos',
        textVB: 'Seleccionar todos',
        textE: 'Seleccionar todos',
        textAG: 'Seleccionar todos'
      },
      allSelected: {
        appsAmulenPersonal: false,
        appsAmulenCore: false,
        appsVistoBueno: false,
        appsElearning: false,
        appsAgendaApp: false
      },
      form: {
        name: '',
        lastname: '',
        email: '',
        rut: '',
        id: '',
        companies: [],
        appIdsAmulenPersonal: [],
        appIdsAmulenCore: [],
        appIdsVistoBueno: [],
        appIdsElearning: [],
        appIdsAgendaApp: [],
        selectAgendaProfile: '',
        expertId: null,
        anual: false
      },
      staffs: [],
      user: {},
      clientLogin: localStorage.getItem('clientName')
    }
  },
  methods: {
    togglePasswordVisibility () {
      this.passwordVisible = !this.passwordVisible
    },
    selectAllAmulenPersonal () {
      this.form.appIdsAmulenPersonal = []

      if (!this.allSelected.appsAmulenPersonal) {
        for (this.app in this.appsAmulenPersonal) {
          this.form.appIdsAmulenPersonal.push(this.appsAmulenPersonal[this.app].id.toString())
        }
      }
      this.selectText.textAP = this.allSelected.appsAmulenPersonal ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    selectAllAmulenCore () {
      this.form.appIdsAmulenCore = []

      if (!this.allSelected.appsAmulenCore) {
        for (this.app in this.appsAmulenCore) {
          this.form.appIdsAmulenCore.push(this.appsAmulenCore[this.app].id.toString())
        }
      }
      this.selectText.textAC = this.allSelected.appsAmulenCore ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    selectAllVistoBueno () {
      this.form.appIdsVistoBueno = []

      if (!this.allSelected.appsVistoBueno) {
        for (this.app in this.appsVistoBueno) {
          this.form.appIdsVistoBueno.push(this.appsVistoBueno[this.app].id.toString())
        }
      }
      this.selectText.textVB = this.allSelected.appsVistoBueno ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    selectAllElearning () {
      this.form.appIdsElearning = []
      if (!this.allSelected.appsElearning) {
        for (this.app in this.appsElearning) {
          this.form.appIdsElearning.push(this.appsElearning[this.app].id.toString())
        }
      }
      this.selectText.textE = this.allSelected.appsElearning ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    selectAllAgendaApp () {
      this.appIdsAgendaApp = []

      if (!this.allSelected.appsAgendaApp) {
        for (this.app in this.appsAgendaApp) {
          this.appIdsAgendaApp.push(this.appsAgendaApp[this.app].id.toString())
        }
      }
      this.selectText.textAG = this.allSelected.appsAgendaApp ? 'Seleccionar todos' : 'Deseleccionar todos'
    },
    select: function () {
      this.allSelected.appsAmulenPersonal = false
      this.allSelected.appsAmulenCore = false
      this.allSelected.appsVistoBueno = false
      this.allSelected.appsElearning = false
      this.allSelected.appsAgendaApp = false
    },
    loadUserData (userEdit) {
      this.form = {
        ...this.form,
        name: userEdit.name,
        lastname: userEdit.lastname,
        email: userEdit.email,
        rut: userEdit.rut,
        ...(userEdit.companies ? { companies: userEdit.companies } : {}),
        ...(userEdit.permissions.amulenPersonal ? { appIdsAmulenPersonal: userEdit.permissions.amulenPersonal } : []),
        ...(userEdit.permissions.amulenCore ? { appIdsAmulenCore: userEdit.permissions.amulenCore } : []),
        ...(userEdit.permissions.vistoBueno ? { appIdsVistoBueno: userEdit.permissions.vistoBueno } : []),
        ...(userEdit.permissions.elearning ? { appIdsElearning: userEdit.permissions.elearning } : []),
        ...(userEdit.permissions.agenda ? { appIdsAgendaApp: userEdit.permissions.agenda } : []),
        selectAgendaProfile: userEdit.permissions.agendaProfile,
        elearningProfile: userEdit.permissions.elearningProfile,
        id: this.$store.state.userEdit.id,
        expertId: userEdit.permissions.expert,
        anual: userEdit.anual
      }
    },
    async editUser () {
      await appisAmulenCore({
        method: 'put',
        url: '/user',
        data: {
          name: this.form.name,
          lastname: this.form.lastname,
          ...(this.form.password ? { password: this.form.password } : {}),
          rut: this.form.rut.toLowerCase(),
          email: this.form.email,
          _id: this.$store.state.userEdit.id,
          permissions: {
            vistoBueno: this.form.appIdsVistoBueno,
            amulenPersonal: this.form.appIdsAmulenPersonal,
            amulenCore: this.form.appIdsAmulenCore,
            elearning: this.form.appIdsElearning,
            elearningProfile: this.form.elearningProfile,
            agenda: this.form.appIdsAgendaApp,
            agendaProfile: this.form.selectAgendaProfile,
            expert: this.form.expertId
          },
          companies: this.form.companies,
          anual: this.form.anual
        }
      })
      return this.$router.push('/')
    },
    async getListCourses () {
      const testsElearning = []
      let response
      if (['cursos-grabados', 'Aulatributaria', 'reunion-tributaria'].includes(this.clientLogin)) {
        response = await appisElearning2.get('/info-test')
        this.appsElearning = response.data
      }
      if (this.appsElearning) {
        this.appsElearning.forEach(element => {
          testsElearning.push({
            title: element.title,
            id: element.courseId,
            active: element.active ? element.active : true,
            number: element.number ? element.number : ''
          })
          sessionStorage.setItem('elearning', JSON.stringify(testsElearning))
        })
      }
    },
    async getListCompanies () {
      this.formatedListCompanies = []
      const response = await appisAmulenApi.get('/enterprise')
      this.allListCompanies = response.data
      this.allListCompanies.map(async company => {
        this.formatedListCompanies.push({
          name: company.nombre,
          id: company.id
        })
      })
    },
    async getListSubsidiary () {
      this.formatedListSubsidiary = []
      try {
        const response = await appisAmulenApi.get('/subsidiary')
        this.allListSubsidiary = response.data
        this.allListSubsidiary.map(async subsidiary => {
          this.formatedListSubsidiary.push({
            subsidiary: [
              {
                nomenclature: subsidiary.nomenclatura,
                nameSubsidiary: subsidiary.nombre,
                idSubsidiary: subsidiary.id,
                idCompanySubsidiary: subsidiary.ini_empresa_id
              }
            ]
          })
        })
      } catch (error) {
      }
    },
    setSubsidiaries () {
      const newArray = this.allListCompanies.reduce((acc, company) => {
        const subsidiaryFounds = this.allListSubsidiary.filter(
          subsidiary => company.id === subsidiary.ini_empresa_id
        )
        acc.push({
          name: company.nombre,
          subsidiary: subsidiaryFounds
        })
        return acc
      }, [])
      this.options = newArray
    },
    subsidiaryLabel ({ nombre, nomenclatura }) {
      return `${nombre} — ${nomenclatura}`
    },
    async getStaff () {
      const response = await appisAmulenApi.get('/staff')
      response.data.forEach(element => {
        this.staffs.push({
          nombre: `${element.nombre.toUpperCase()} ${element.ape_pat.toUpperCase()} ${element.ape_mat.toUpperCase()} (${element.rut})`,
          id: element.id
        })
      })
    }
  },
  created () {
    this.$emit('update:layout', DefaultLayout)
    const datosElearning = JSON.parse(sessionStorage.getItem('elearning'))
    if (datosElearning === null) {
      this.testsElearning = []
    } else {
      this.testsElearning = datosElearning
    }
  },
  async mounted () {
    if (!['Aulatributaria', 'cursos-grabados', 'reunion-tributaria'].includes(this.clientLogin)) {
      await this.getListCompanies()
      await this.getListSubsidiary()
      await this.getStaff()
      this.setSubsidiaries()
    }
    await this.getListCourses()
  },
  beforeMount () {
    this.loadUserData(this.$store.state.userEdit)
  },
  beforeCreate () {
  }
}
</script>

<style lang="stylus" scoped>
  #tittle
    color: #43ADE1
  .button
    border: none
    color: white
    border-radius: 6px
    height: 50px;
  #buttonSave
    background: #43ADE1
  #buttonSave:hover
    background: #2D9CD3
  #buttonCancel
    background: #A6B5BD
  #buttonCancel:hover
    background: #81888C
</style>
